module.exports = function frontHeaderAnimiation() {
  var slides = document.querySelectorAll('.front-header.item');

  if (! slides.length) return;

  let index = 0;
  let lastIndex = 0;

  // Animate slides by toggling class
  window.setInterval(() => {
    index = index + 1;

    if (index > slides.length - 1) index = 0;

    slides.item(lastIndex).classList.remove('active');
    slides.item(index).classList.add('active');

    lastIndex = index;
  }, 1200);
};
